<template>
  <a-box>
    <l-rows>
      <a-title
        :text="label"
        size="4"
      />
      <div class="list-input">
        <div
          v-for="(numberValue, index) in addValues"
          :key="numberValue"
          class="list-input__tag"
        >
          <span @click="removeNumber(index)">x</span>
          {{ numberValue }}
        </div>
        <input
          type="text"
          :placeholder="placeholder"
          class="list-input__text"
          @keydown.enter="addNumber"
          @keydown.188="addNumber"
          @keydown.delete="removeLastSize"
          @paste="pastValues"
          @keypress="isNumber"
        >
      </div>
    </l-rows>
  </a-box>
</template>

<script>

  import { ABox, ATitle, LRows } from 'codefabrik-gui-vue'
  export default {
    name: "NumberListInput",
    components: { ABox, LRows, ATitle },

    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        type: Array,
        default () { return [] }
      }
    },
    data () {
      return {
        addValues: this.value.slice()
      }
    },
    methods: {
      pastValues(event) {
        event.preventDefault()
        const sizes = event.clipboardData.getData('text').split(",");
        this.$emit('input',this.addValues);
        sizes.map(it => it.trim())
          .filter(it => it.length > 0)
          .filter(it => !isNaN(it))
          .map(it => parseInt(it))
          .sort((a, b) => a - b)
          .forEach(v => this.addValues.push(v))
      },
      addNumber (event) {
        event.preventDefault()
        if(this.addValues == null) return;
        if(!event.target.value.trim()) return;

        const val = parseInt(event.target.value.trim());
        if (!this.addValues.includes(val)) {
          this.addValues.push(val)
          this.addValues = this.addValues.sort((a, b) => a - b);
          event.target.value = ''
          this.$emit('input', this.addValues);
        }
      },
      removeNumber (index) {
        this.addValues.splice(index, 1)
        this.$emit('input', this.addValues);
      },
      removeLastSize(event) {
        if (event.target.value.length === 0) {
          this.removeNumber(this.addValues.length - 1)
          this.$emit('input', this.addValues);
        }
      },
      isNumber: function(event) {
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          event.preventDefault();
        } else {
          return true;
        }
      }
    }
  }
</script>
<style scoped>
.list-input {
  width: 100%;
  border: 1px solid #dbdbdb;
  font-size: 0.9em;
  height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
}

.list-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  background-color: #cbcbcb;
  margin-top: 10px;
  line-height: 30px;
  padding: 0 5px;
  border-radius: 5px;
}

.list-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}

.list-input__text {
  border: 1px;
  outline: none;
  font-size: 0.9em;
  line-height: 50px;
  background: none;
}
</style>
